import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Read all params sent by the backend redirect
  const reason        = searchParams.get('reason')         || 'Transaction declined';
  const txn           = searchParams.get('txn')            || '—';
  const gateway       = searchParams.get('gateway')        || '—';
  const subscriptionId = searchParams.get('subscriptionId');
  const userId        = searchParams.get('userId');

  // Build retry URL (back to payment-selector on the backend)
  // REACT_APP_BACKEND_URL is set via .env (sandbox) or .env.production (prod) automatically
  const backendBase = (process.env.REACT_APP_BACKEND_URL || 'https://us-central1-texpideaadmin.cloudfunctions.net/api').replace(/\/+$/, '');
  const retryUrl = subscriptionId && userId
    ? `${backendBase}/payment-selector?subscriptionId=${encodeURIComponent(subscriptionId)}&userId=${encodeURIComponent(userId)}`
    : null;

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        {/* Failure icon */}
        <div style={styles.iconCircle}>
          <svg viewBox="0 0 24 24" fill="none" stroke="#c0392b" strokeWidth="2.5"
            strokeLinecap="round" strokeLinejoin="round" width="38" height="38">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </div>

        <h1 style={styles.title}>Payment Failed</h1>
        <p style={styles.subtitle}>
          Your transaction could not be completed. No amount has been deducted.
        </p>

        {/* Transaction details */}
        <div style={styles.details}>
          <DetailRow label="Reason" value={reason} />
          <DetailRow label="Transaction ID" value={txn} small />
          <DetailRow label="Gateway" value={gateway} last />
        </div>

        {/* Action buttons */}
        <div style={styles.actions}>
          {retryUrl && (
            <a href={retryUrl} style={{ ...styles.btn, ...styles.btnRetry }}>
              Try Again
            </a>
          )}
          <button
            style={{ ...styles.btn, ...styles.btnHome }}
            onClick={() => navigate('/')}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

const DetailRow = ({ label, value, small, last }) => (
  <div style={{ ...styles.row, ...(last ? { borderBottom: 'none', marginBottom: 0, paddingBottom: 0 } : {}) }}>
    <strong style={styles.rowLabel}>{label}</strong>
    <span style={{ ...styles.rowValue, ...(small ? { fontSize: '0.82rem', wordBreak: 'break-all', textAlign: 'right', maxWidth: '60%' } : {}) }}>
      {value}
    </span>
  </div>
);

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
    background: 'radial-gradient(circle at top right, #ffd6d6 0%, rgba(255,214,214,0) 50%), #fff7f7',
    fontFamily: '"Segoe UI", -apple-system, BlinkMacSystemFont, sans-serif',
    color: '#2d1010',
  },
  card: {
    background: '#fff',
    border: '1px solid #f5c6c6',
    borderRadius: '18px',
    boxShadow: '0 12px 40px rgba(60,10,10,0.09)',
    padding: '36px 28px',
    maxWidth: '440px',
    width: '100%',
    textAlign: 'center',
  },
  iconCircle: {
    width: '72px',
    height: '72px',
    background: '#fff0f0',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 20px',
  },
  title: {
    fontSize: '1.5rem',
    marginBottom: '8px',
    color: '#c0392b',
    fontWeight: '700',
  },
  subtitle: {
    fontSize: '0.97rem',
    color: '#7c4a4a',
    marginBottom: '24px',
    lineHeight: '1.55',
  },
  details: {
    background: '#fff0f0',
    border: '1px solid #f5c6c6',
    borderRadius: '12px',
    padding: '16px',
    textAlign: 'left',
    fontSize: '0.95rem',
    lineHeight: '1.8',
  },
  row: {
    borderBottom: '1px solid #f5c6c6',
    paddingBottom: '8px',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  rowLabel: { color: '#2d1010', fontWeight: '600' },
  rowValue: { color: '#7c4a4a', textAlign: 'right', maxWidth: '60%', wordBreak: 'break-all', fontSize: '0.9rem' },
  actions: {
    marginTop: '24px',
    display: 'flex',
    gap: '10px',
  },
  btn: {
    flex: 1,
    display: 'block',
    padding: '13px',
    border: 'none',
    borderRadius: '12px',
    fontSize: '1rem',
    fontWeight: '600',
    cursor: 'pointer',
    textDecoration: 'none',
    textAlign: 'center',
  },
  btnRetry: {
    background: '#c0392b',
    color: '#fff',
  },
  btnHome: {
    background: '#f0f0f0',
    color: '#2d1010',
  },
};

export default PaymentFailure;
